/**
 * Reads and immediately clears the admin → public "create request on behalf" cookie.
 *
 * The value is forwarded to `/users/login` explicitly rather than letting the browser
 * attach the cookie: the web app and the API are separate origins, and in QA they are
 * even on separate schemes (http web → https API), which makes the login XHR cross-site.
 * A cookie without `SameSite=None` is dropped on such a request — and `SameSite=None`
 * is not an option, because it requires `Secure`, which cannot be written from the
 * http:// admin origin. Reading it here sidesteps all of that: `document.cookie` is not
 * subject to SameSite, and admin/public share a registrable domain in every environment.
 */
const ON_BEHALF_ROLE_ID_COOKIE = "onBehalfRoleId";

const clearCookie = (): void => {
  const cookieDomain = process.env.REACT_APP_AUTH_COOKIE_DOMAIN;

  document.cookie = `${ON_BEHALF_ROLE_ID_COOKIE}=;domain=${cookieDomain};path=/;max-age=0;`;
};

export const consumeOnBehalfRoleId = (): number | undefined => {
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${ON_BEHALF_ROLE_ID_COOKIE}=(\\d+)`)
  );

  if (!match) {
    return undefined;
  }

  // One-shot: the role must not be re-applied on every subsequent page load,
  // otherwise the user could never switch back to their Parent role.
  clearCookie();

  return Number(match[1]);
};
